/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function() {
   'use strict';
   angular.module('com.vmware.vsphere.client.vm')
         .constant('NetworkPageViewModes', {
            BASIC: 'basic',
            ADVANCED: 'advanced'
         });
}());
